"use strict";

var documentClickCloseModal = function documentClickCloseModal() {
  document.addEventListener('click', function (event) {
    var _document = document,
        body = _document.body;

    if (document.querySelector('.modal--open') != null || document.querySelector('.modal--open') != undefined) {
      var isModalOpen = document.querySelector('.modal--open');
      var openModalContainer = isModalOpen.querySelector('.modal__container');

      if (isModalOpen) {
        var isClickingModal = isModalOpen.querySelector('.modal__container').contains(event.target);

        if (!isClickingModal) {
          openModalContainer.className = 'modal__container modal__container--reverse-grow'; // Remove modal--open to hide modal

          setTimeout(function () {
            body.className = body.className.replace('modal-open', '');
            isModalOpen.className = isModalOpen.className.replace(' modal--open', '');
          }, 200);
        }
      }
    }
  });
};

var closeModalButtons = function closeModalButtons(selectedModal, bodyClasses) {
  var modalContainer = selectedModal.querySelector('.modal__container');
  var closeButtons = selectedModal.querySelectorAll('[class*="modal__close"]');

  for (var i = 0; i < closeButtons.length; i += 1) {
    closeButtons[i].addEventListener('click', function () {
      modalContainer.className = modalContainer.className.replace('modal__container--grow', 'modal__container--reverse-grow'); // Remove modal--open to hide modal

      setTimeout(function () {
        document.body.setAttribute('class', bodyClasses);
        selectedModal.className = selectedModal.className.replace(' modal--open', '');
      }, 200);
    });
  }
};

var openModal = function openModal(modal) {
  return function (event) {
    // Prevent documentClickCloseModal() from happening
    event.preventDefault();
    event.stopPropagation();
    var modalId = modal.getAttribute('data-modal');
    var _document2 = document,
        body = _document2.body;
    var selectModal = document.getElementById(modalId);
    var modalClasses = "".concat(selectModal.getAttribute('class'), " ");
    var modalContainer = selectModal.querySelector('.modal__container');
    var bodyClasses = body.getAttribute('class'); // Prevent null from being the value returned if no classes

    bodyClasses = bodyClasses || ''; // Apply modal-open class to body

    body.setAttribute('class', "".concat(bodyClasses, "modal-open")); // Apply modal--open to modal parent

    selectModal.setAttribute('class', "".concat(modalClasses, "modal--open")); // Apply grow to modal container

    modalContainer.className = 'modal__container modal__container--grow';
    closeModalButtons(selectModal, bodyClasses);
  };
};

var modal = function modal() {
  var modalButton = document.querySelectorAll('[data-modal]');

  for (var i = 0; i < modalButton.length; i += 1) {
    modalButton[i].addEventListener('click', openModal(modalButton[i]));
  }

  documentClickCloseModal();
};

modal();